import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { Qna } from 'actions/actionTypes';
import * as actions from 'actions/customerService/qna';

import { callQnaList, callAddQnaQuestion, callQnaInfo } from 'network/apis/customerService/qna';

import History from 'routes/history';

// 문의 목록 조회 사가 함수
function* loadQnAListRequestSaga() {
    try {
        const qna = yield select(state => state.qna);
        
        const data = {
            page: qna.searchFilter.page,
            pageSize: qna.searchFilter.pageSize,
            QnATypeCode: qna.searchFilter.qnaTypeCode,
        };

        const response = yield call(callQnaList, data);

        yield put(actions.loadQnaListSuccess(response.data));
    } catch(error) {
        yield put(actions.loadQnaListFailure(error.message));
    }
}

// 문의 등록 사가 함수
function* AddQuestionRequestSaga() {
    try {
        const qna = yield select(state => state.qna);

        const headers = { 'Content-Type': 'multipart/form-data' };

        const data = new FormData();
        data.append('qnaTypeCode', qna.question.qnaTypeCode);
        data.append('title', qna.question.title);
        data.append('content', qna.question.content);

        if(qna.question.attachments1 != null){
            data.append('attachments', qna.question.attachments1);
        }

        if(qna.question.attachments2 != null){
            data.append('attachments', qna.question.attachments2);
        }

        if(qna.question.attachments3 != null){
            data.append('attachments', qna.question.attachments3);
        }

        if(qna.question.attachments4 != null){
            data.append('attachments', qna.question.attachments4);
        }

        if(qna.question.attachments5 != null){
            data.append('attachments', qna.question.attachments5);
        }

        const response = yield call(callAddQnaQuestion, headers, data);

        yield put(actions.addQnaQuestionSuccess(response.data));
        yield put(actions.loadQnaListRequest());

        alert('문의 등록이 완료되었습니다.');

        History.push('/qna');
    } catch(error) {
        yield put(actions.addQnaQuestionFailure(error.message));
    }
}

// 문의 정보 조회 사가 함수
function* loadQnAInfoRequestSaga() {
    try {
        const qna = yield select(state => state.qna);

        const response = yield call(callQnaInfo, qna.qnaInfo.idx);

        yield put(actions.loadQnaInfoSuccess(response.data));
    } catch(error) {
        yield put(actions.loadQnaInfoFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(Qna.LOAD_QNA_LIST_REQUEST, loadQnAListRequestSaga),
        takeLatest(Qna.ADD_QNA_QUESTION_REQUEST, AddQuestionRequestSaga),
        takeLatest(Qna.LOAD_QNA_INFO_REQUEST, loadQnAInfoRequestSaga),
    ]);
}